import * as Types from './types';
import { createReducer } from '../../utils';

const initialState = {
  loading: false,
  error: false,
  userStatus: 0,
  blockedUserMessageKey: ''
};

const blockedUserReducer = createReducer(initialState)({
  [Types.FETCH_USER_PERMISSION]: state => ({ ...state, loading: true, error: null }),
  [`${Types.FETCH_USER_PERMISSION}_COMPLETED`]: (state, action) => ({
    ...state,
    loading: false,
    error: null,
    userStatus: action.payload.code,
    blockedUserMessageKey: action.payload.key
  }),
  [`${Types.FETCH_USER_PERMISSION}_FAILED`]: (state, action) => ({
    ...state,
    loading: false,
    error: action.payload,
    userStatus: action.payload.data.code,
    blockedUserMessageKey: action.payload.data.key
  })
});

export { blockedUserReducer };
